export default __webpack_public_path__ + "/dist/images/image00001.da621992bcdb7a30c4de12c97c114291.jpeg";